export type Size = 'sm' | 'md' | 'lg' | 'xlg' | 'xxlg' | 'xxxlg'

export const intSizes: Record<Size, number> = {
  sm: 375,
  md: 768,
  lg: 1024,
  xlg: 1280,
  xxlg: 1440,
  xxxlg: 1920,
}

const keys = Object.keys(intSizes) as Size[]

export const mirandaSizes = keys.reduce(
  (result, sizeName) => ({
    ...result,
    [sizeName]: `${intSizes[sizeName]}px`,
  }),
  {} as Record<Size, string>
)

export const mirandaScreen = keys.reduce(
  (result, sizeName) => ({
    ...result,
    [sizeName]: `@media (min-width: ${mirandaSizes[sizeName]})`,
  }),
  {} as Record<Size, string>
)
